import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export default function CategoryCard({ slug, name, icon, description }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 hover:bg-accent-50/30 transition-all duration-300 cursor-pointer"
    >
      <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors duration-300">
        <i className={`${icon} text-accent-600 text-xl`}></i>
      </div>
      <span className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{name}</span>
      <span className="text-xs text-foreground-500 text-center leading-relaxed">{description}</span>
    </Link>
  );
}